import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { enLocale } from './locales/en';
import { esLocale } from './locales/es';
import { frCALocale } from './locales/fr-CA';
import { frLocale } from './locales/fr';

const resources = {
  en: {
    translation: enLocale,
  },
  fr: {
    translation: frLocale,
  },
  'fr-CA': {
    translation: frCALocale,
  },
  es: {
    translation: esLocale,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    interpolation: {
      escapeValue: false,
    },
    fallbackLng: {
      // Default for non-supported languages
      default: ['en'],
    },
    detection: {
      order: ['navigator'],
      caches: [],
    },
  });

export default i18n;
